import { render, staticRenderFns } from "./ClockOutline.vue?vue&type=template&id=3b16436a&"
import script from "./ClockOutline.vue?vue&type=script&lang=ts&"
export * from "./ClockOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports